import styled from "styled-components";
import Img2 from "web/assets/images/customized-solutions-worker-laptop-factory.png"
// import Img2 from "../../../../assets/images/8Rectangle.png";

export const Container = styled.div``;
export const Wrapper = styled.div`
h1,
    h2,
    h3,
    h4 {
      font-family: ITC Franklin Gothic Std;
    }
  max-width: 1440px;
  margin: 0 auto;
  p{
    font-size: 1.5rem;
   }
   h2 {
    font-size: 2.759rem;
  }
  @media (max-width: 1024px){
    p{
      font-size: 14px;
    }
    h2{
      font-size: 2rem;
    }
    li{
      font-size: 14px !important;
    }
  }
  @media (max-width: 1024px){
    p{
      font-size: 14px;
    }
    h2{
      font-size: 2rem;
    }
    li{
      font-size: 14px !important;
    }
  }
  h2{
    @media (max-width: 767px) {
        font-size: 2rem !important;
    }
  }
  h4{
    @media (max-width: 767px) {
        font-size: 32px !important;
    }
  }
  p{
    @media (max-width: 767px) {
        font-size: 14px !important;
    }
  }
  button {
    background-color: #233354;
    font-weight: 400;
    color: rgb(255, 255, 255);
    border: none;
    margin-top: min(1.75vw, 25px);
    font-size: 14px;
    padding: 8px 20px;
    width: 250px;
  }
  .our_expertise {
    background-color: #e3f1fb;
    width: 100%;
    background-repeat: repeat;
    background-position: right;
    /* margin-bottom: 4vw !important; */
    &.suppliers {
      background-image: url(${Img2});
      background-size: cover;
      height: 400px;
      @media (max-width: 1024px){
        height: 300px;
      }
      @media (max-width: 767px){
        height: 144px !important;
      }
    }
    .expertise_overlay {
      /* background: linear-gradient(109deg, #ee0000bf 50%, transparent 50%); */
      background: linear-gradient(109deg, #d20e0ee8  50%, transparent 50%);
      height: 400px;
      color: #ffffff;
      padding: 16px;
      padding-left: 6.25vw;
      padding-right: 6.25vw;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      h2 {
        font-size: 4rem;
        font-weight: 500;
      }
    }
    @media (max-width: 1024px) {
      .expertise_overlay {
        height: 300px;
        h2 {
          font-size: 3rem;
        }
      }
    }
    @media (max-width: 767px) {
      background-size: cover;
      .expertise_overlay {
        background: linear-gradient(180deg, #ee0000c4 50%, #e3f1fb 34%);
        height: 270px;
        flex-direction: column;
        h2 {
          font-size: 36px !important;
        }
        p {
          font-size: 14px;
        }
        .digital_supplier_img {
          img {
            max-width: 290px;
          }
        }
        .grid {
          display: grid;
          button {
            background-color: #ffffff;
            color: #ee0000;
            width: 270px;
          }
        }
      }
      &.suppliers {
        .expertise_overlay {
          background: linear-gradient(180deg, #ee0000c4 100%, #e3f1fb 34%);
          height: 144px !important;
          justify-content: center;
        }
      }
    }
  }
  .pallet_faq {
    margin: 2.5vw 3.5vw;
    @media (max-width: 767px) {
      .our{
        font-size: 2rem !important;
      }
      margin: 5.5vw 3.5vw !important;
        }
        @media (max-width: 1024px){
          margin: 3.5vw 3.5vw;
        }
    .faq-head {
      text-align: center;
      margin-bottom: 40px;
      h2 {
        font-family: ITC Franklin Gothic Std;
        color: #233354;
        @media (max-width: 767px){
        }
      }
      p {
        color: #231f20;
        max-width: 306vh;
        text-align: center;
        margin: 16px auto;
        margin-top: 5px;
      }
    }
    .market{
      @media (max-width: 1024px){
          font-size:1.7rem !important;
        }
       @media (max-width : 410px){
        display: contents;
       } 
    }
  }
  .digital_supplier {
    display: grid;
    grid-template-columns: 1fr 1fr;
    /* margin-top: -20px; */
    .digital_supplier_img {
      background-color: #e3f1fb;
      /* padding: 3vw 16px 3vw 6.25vw; */
    text-align: center;
    place-items: center;
    padding: max(2.083vw, 42px);
    }
    .digital_supplier-text {
      background-color: #233354;
      color: #ffffff;
      padding: 20px;
      display: grid;
      place-items: center;
      div {
        max-width: 410px;
      }
      h2 {
        margin-bottom: 40px;
      }
      button {
        background-color: #ffffff;
        color: #233354;
      }
    }
    @media (max-width: 1024px) {
      .digital_supplier_img {
        img {
          max-width: 300px;
        }
      }
    }
    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      margin: 5.5vw 3.5vw !important;
      width: auto;
      .digital_supplier_img {
        padding: 16px;
        display: flex;
        justify-content: center;
        img {
          max-width: 190px;
        }
      }
      .digital_supplier-text {
        h2 {
          font-size: 20px;
          margin-bottom: 20px;
        }
        p {
          font-size: 14px;
        }
      }
    }
  }
   
  
    .what_you_get {
    font-family: sans-serif;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    /* padding: 3rem 15rem 6rem 15rem; */
    margin: 4vw 0;
    transform: scale(1);
    -ms-transform: scale (1);
    -webkit-transform:scale(1);
    -moz-transform: scale(1);
    -o-transform: scale(1);

    

    .what_you_get-container {
      background: #efefef;
    }

    .what_you_get-container > h2 {
      font-family: ITC Franklin Gothic Std;
      color: #233354;
      /* font-size: 2.5rem; */
      text-align: center;
      padding: 1.2rem;
      @media (max-width: 767px){
        font-size: 2rem !important;
      }
    }

    .what_you_get-container > p {
      text-align: center;
    }

    .what_you_get-container .cards-container {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 1rem;
    }
    .what_you_get-container .cards-container .card {
      display: flex;
      flex-direction: column;
    }

    .what_you_get-container .cards-container .card .img-box {
      background: #e4f1f9;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1rem 1rem;
      position: relative;
      height: 168px;
      border: 2px solid #233354;
    }

    .what_you_get-container .cards-container .card .text-box .hover-box {
      background: #233354;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      /* padding: 1.3rem 1.6rem 1.5rem 1.6rem; */
      padding: 1.3rem;
      text-align: center;
      position: absolute;
      width: 100%;
      /* transform: translate(-15%, -100%); */
      transform: scale(0);
      top: 0;
      left: 0;
      border: 1px solid #a6a6a6;
      z-index: 10;
      box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
      transition: all 0.4s;
      h4 {
        color: #ffffff;
      }
    }

    .what_you_get-container .cards-container .card .text-box .hover-box.active {
      display: flex;
      transform: scale(1.04);
      transition: all 0.4s;
      @media (max-width: 767px) {
        transform: scale(1);
        width: 100%;
      }
    }

    .what_you_get-container .cards-container .card .text-box .hover-box ul {
      margin: 0;
      margin-top: 1.3rem;
      padding: 0;
      color: #fff;
      list-style: none;
      text-align: start;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      font-size: 0.85rem;
    }

    .what_you_get-container .cards-container .card .text-box .hover-box > img {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 0.6rem;
      height: auto;
      cursor: pointer;
    }

    .what_you_get-container .cards-container .card .text-box .hover-box ul li {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
      font-size: 19px;
      @media (max-width: 1024px){
        font-size: 15px;
      }
    }

    .what_you_get-container .cards-container .card .text-box .hover-box ul li img {
      width: 10px;
      height: auto;
      padding-top: 0.3rem;
    }

    .what_you_get-container .cards-container .card .text-box img {
      max-width: 100%;
      height: 100px;
      object-fit: contain;
    }

    .what_you_get-container .cards-container .card .text-box {
      background: #233354;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 1.3rem 1rem 1rem 1rem;
      text-align: center;
      gap: 0.5rem;
      flex: 1 1 0%;
      line-height: 190%;
      position: relative;
    }

    .what_you_get-container .cards-container .card .text-box > h4,
    .what_you_get-container .cards-container .card .img-box .hover-box > h4 {
      font-size: 38px;
      color: #fff;
      font-weight: 500;
      margin: 0;
      @media (max-width: 1024px){
        font-size: 23px;
      }
      @media (max-width: 410px){
        font-size: 1.5rem !important;
      }
    }

    .what_you_get-container .cards-container .card .text-box > p {
      font-size: 1.2rem;
      color: #23759f;
      text-decoration: underline;
      margin: 0;
      cursor: pointer;
    }
    @media (max-width: 767px) {
      .cards-container {
        display: grid !important;
        grid-template-columns: 1fr !important;
        padding: 0 16px;
        .hover-box {
        }
      }
    }
    /* for tablet */
    @media (min-width: 500px) and (max-width: 1050px) {
    }

    /* For Mobile */
    @media (max-width: 500px) {
    }
  }
  
    .color_box_wrp {
    margin: 3.5vw;
    margin-top: -25px;
    display: grid;
    grid-template-rows: repeat(6, 1fr);
    @media (max-width: 410px){
      h4{
        font-size: 1.5rem !important;
      }
    }
    @media (max-width:767px){
      grid-template-rows: auto;
    }
    h4{
      font-size: 2rem;
    }
  }
`;

export const ColorBox = styled.section`
h1,
    h2,
    h3,
    h4 {
      font-family: ITC Franklin Gothic Std;
    }
  display: grid;
  grid-template-columns: 400px 1fr;
  margin: 30px 0;

  .color_body {
    padding: 24px;
    p {
      margin: 6px 0;
    }
    li {
      list-style: disc;
      margin-left: 20px;
      font-size: 24px;
    }
    &.gry {
      background-color: #f0f0f2;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }
    &.light_sky {
      background-color: #e3f1fb;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }
  }
  .color_head {
    padding: 24px;
    color: #ffffff;
    display: flex;
    align-items: center;
    gap: 10px;
    &.blue {
      background-color: #003471;
    }
    &.sky {
      background-color: #56baff;
    }
    &.ocean {
      background-color: #005586;
    }
  }
  

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    margin-top: 0;
    h4 {
      font-size: 18px;
    }
    .color_body {
      padding: 8px 24px;
    }
  }
  @media(max-width: 360px) { 
    .color_head{
      padding: 4px;
      h4{
      font-size: 28px;
     }
    }
    
   }
`;
